const ChevronButton = ({ isOpen }) => {
  return (
    <img
      src={isOpen ? "/static/chevron-up.svg" : "/static/chevron-down.svg"}
      alt="chevron"
    />
  );
};

export default ChevronButton;
